export default "__VITE_ASSET__OB8EzQz4__"